export default "__VITE_ASSET__5b770f49__"